import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Alert from "components/alert-view";
import {
  FormattedMessage,
  defineMessages,
} from "react-intl";
import classes from "./alert.scss";
import appconfig from "config/appconfig";
import { Button ,Typography } from "@getgo/chameleon-web-react-wrapper";
import { AlertOutlinedIcon } from '@getgo/chameleon-icons/react';
import useAnalyticsHelpers from "lib/analytics-helpers";

const t = defineMessages({
  "alert.auth.warning.message": {
    id: "alert.auth.warning.message",
    defaultMessage: "Your session is about to expire. Save your work and reload the page.",
  },
  "alert.auth.warning.time": {
    id: "alert.auth.warning.time",
    defaultMessage: "{timeLeft} seconds remaining.",
  },
  "alert.auth.warning.buttonReload": {
    id: "alert.auth.warning.buttonReload",
    defaultMessage: "Reload",
  },
});

export const AlertAuthWarning = ({
  handleAlertDismiss,
  handleReload,
  timeLeft,
}) => {
  const { track } = useAnalyticsHelpers();

  useEffect(() => {
    track('Alert Shown', {
      alertType: 'auth_warning',
      alertMessage: 'Your session is about to expire',
    });
  }, [track]);

  const handleReloadClick = () => {
    track('Alert Action Clicked', {
      alertType: 'auth_warning',
      action: 'reload',
    });
    handleReload();
  };

  const handleDismissClick = () => {
    track('Alert Dismissed', {
      alertType: 'auth_warning',
    });
    handleAlertDismiss();
  };

  return (
    <Alert
      type={appconfig.alertTypes.WARNING}
      icon={<AlertOutlinedIcon/>}
      body={
        <span className={classes.bannerMessageText} role="timer" aria-live="off">
          <FormattedMessage {...t["alert.auth.warning.message"]} />
          <span className={classes.secondPartOfText}>
            {timeLeft && (
              <FormattedMessage
                {...t["alert.auth.warning.time"]}
                values={{ timeLeft: <strong>{timeLeft}</strong> }}
              />
            )}
          </span>
        </span>
      }
      action={
        <Button
          id="auth-warning-reload"
          size="small"
          variant="neutral"
          className={classes.bannerMessageCTA}
          onClick={handleReloadClick}
        >
          <Typography variant="button-small" color="brand-color-black">
            <FormattedMessage {...t["alert.auth.warning.buttonReload"]} />
          </Typography>
        </Button>
      }
      handleDismiss={handleDismissClick}
    />
  );
};

AlertAuthWarning.propTypes = {
  timeLeft: PropTypes.number,
  handleAlertDismiss: PropTypes.func.isRequired,
  handleReload: PropTypes.func.isRequired,
};

export default AlertAuthWarning;
